import { Stack } from '@mui/material';

import { UserProfileDatesTemplate } from './UserProfileDatesTemplate';

type UserProfileTenantMembershipDatesProps = {
  startDate: string;
  endDate?: string;
  wrapperTestId?: string;
};

export const UserProfileTenantMembershipDates = ({ startDate, endDate, wrapperTestId }: UserProfileTenantMembershipDatesProps) => {
    const startDateCaption = 'Start Date';
    const endDateCaption = 'End Date';
    const startDateValueTestId = 'start-date-value-test-id';
    const endDateValueTestId = 'end-date-value-test-id';

    return (
        <Stack direction="row" spacing={4}>
            <UserProfileDatesTemplate
                label={startDateCaption}
                value={startDate}
                valueTestId={`${wrapperTestId}-${startDateValueTestId}`}
            />
            <UserProfileDatesTemplate
                label={endDateCaption}
                value={endDate}
                valueTestId={`${wrapperTestId}-${endDateValueTestId}`}
            />
            <Stack direction="row" spacing={4}></Stack>
        </Stack>
    );
};
